// extracted by mini-css-extract-plugin
export var errorsContainer = "_u7-1";
export var link = "_u7-0";